
function createSampleCoffeeDropdown(select){
  const wrapper=document.createElement('div');
  wrapper.className='adc-sample__dropdown';
  const trigger=document.createElement('button');
  trigger.type='button';
  trigger.id=select.id+'-choice';
  trigger.className='adc-sample__choice';
  trigger.setAttribute('role','combobox');
  trigger.setAttribute('aria-haspopup','listbox');
  trigger.setAttribute('aria-expanded','false');
  trigger.setAttribute('aria-required',String(select.required));
  const label=select.labels[0];
  if(label){label.id=select.id+'-label';label.htmlFor=trigger.id;trigger.setAttribute('aria-labelledby',label.id+' '+trigger.id+'-name');}
  const thumbnail=document.createElement('img');
  thumbnail.alt='';thumbnail.width=40;thumbnail.height=48;
  const name=document.createElement('span');name.id=trigger.id+'-name';
  const arrow=document.createElement('span');arrow.className='adc-sample__chevron';arrow.textContent='⌄';arrow.setAttribute('aria-hidden','true');
  trigger.append(thumbnail,name,arrow);
  const list=document.createElement('ul');
  list.id=select.id+'-options';list.className='adc-sample__options';list.setAttribute('role','listbox');
  if(label)list.setAttribute('aria-labelledby',label.id);
  list.hidden=true;trigger.setAttribute('aria-controls',list.id);
  const options=[...select.options].filter(option=>option.value&&!option.disabled);
  let active=0;let search='';let searchTimer;
  const items=options.map((option,index)=>{
    const item=document.createElement('li');
    item.id=list.id+'-'+index;item.setAttribute('role','option');item.setAttribute('aria-selected','false');
    const image=document.createElement('img');image.alt='';image.width=40;image.height=48;image.loading='lazy';
    if(option.dataset.image)image.src=option.dataset.image;else image.hidden=true;
    image.addEventListener('error',()=>{image.hidden=true;});
    const text=document.createElement('span');text.textContent=option.textContent;
    item.append(image,text);list.append(item);
    item.addEventListener('pointerdown',event=>event.preventDefault());
    item.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));close();trigger.focus();});
    return item;
  });
  function highlight(index){
    active=(index+items.length)%items.length;
    items.forEach((item,i)=>item.classList.toggle('is-active',i===active));
    if(items[active]){trigger.setAttribute('aria-activedescendant',items[active].id);items[active].scrollIntoView({block:'nearest'});}
  }
  function close(){list.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.removeAttribute('aria-activedescendant');}
  function open(){
    wrapper.closest('form').querySelectorAll('.adc-sample__choice[aria-expanded="true"]').forEach(other=>{if(other!==trigger)other.dispatchEvent(new Event('sample:close'));});
    list.hidden=false;trigger.setAttribute('aria-expanded','true');
    highlight(Math.max(0,options.findIndex(option=>option.value===select.value)));
  }
  function sync(){
    const selected=select.selectedOptions[0];name.textContent=selected?.textContent||'';
    thumbnail.hidden=!selected?.dataset.image;
    if(selected?.dataset.image)thumbnail.src=selected.dataset.image;
    items.forEach((item,i)=>item.setAttribute('aria-selected',String(options[i].value===select.value)));
  }
  thumbnail.addEventListener('error',()=>{thumbnail.hidden=true;});
  trigger.addEventListener('sample:close',close);
  trigger.addEventListener('click',()=>list.hidden?open():close());
  trigger.addEventListener('blur',close);
  trigger.addEventListener('keydown',event=>{
    if(['ArrowDown','ArrowUp','Home','End'].includes(event.key)){
      event.preventDefault();const wasClosed=list.hidden;if(wasClosed)open();
      if(event.key==='Home')highlight(0);else if(event.key==='End')highlight(items.length-1);else if(!wasClosed)highlight(active+(event.key==='ArrowDown'?1:-1));
    }else if(event.key==='Escape'){event.preventDefault();close();}
    else if((event.key==='Enter'||event.key===' ')&&!list.hidden){event.preventDefault();items[active]?.click();}
    else if(event.key.length===1&&event.key!==' '&&!event.ctrlKey&&!event.metaKey&&!event.altKey){
      event.preventDefault();if(list.hidden)open();clearTimeout(searchTimer);search+=event.key.toLocaleLowerCase();
      const index=options.findIndex(option=>option.textContent.trim().toLocaleLowerCase().startsWith(search));
      if(index>=0)highlight(index);searchTimer=setTimeout(()=>{search='';},700);
    }
  });
  select.addEventListener('invalid',event=>{event.preventDefault();trigger.focus();open();});
  select.addEventListener('change',sync);
  select.form.addEventListener('reset',()=>setTimeout(()=>{sync();close();select.dispatchEvent(new Event('change',{bubbles:true}));},0));
  wrapper.append(trigger,list);select.after(wrapper);select.classList.add('adc-sample__select--enhanced');select.tabIndex=-1;select.setAttribute('aria-hidden','true');
  sync();return{sync,close};
}

function initSamplePacks(root=document){
  root.querySelectorAll('.adc-sample__form').forEach(form=>{
    if(form.dataset.sampleReady)return;
    form.dataset.sampleReady='true';
    const selects=[...form.querySelectorAll('[data-sample-coffee]')];
    const dropdowns=selects.map(createSampleCoffeeDropdown);
    const grind=form.querySelector('select[name="id"]');
    const button=form.querySelector('button[type="submit"]');
    const requestedVariant=new URLSearchParams(window.location.search).get('variant');
    if(requestedVariant&&[...grind.options].some(option=>option.value===requestedVariant&&!option.disabled))grind.value=requestedVariant;
    const update=()=>{
      dropdowns.forEach(dropdown=>dropdown.sync());
      selects.forEach(select=>{
        const card=select.closest('.adc-sample__card');
        const image=card.querySelector('.adc-sample__image');
        const number=card.querySelector('.adc-sample__number');
        const source=select.selectedOptions[0]?.dataset.image;
        image.hidden=!source;
        number.hidden=!!source;
        if(source)image.src=source;
      });
      const status=form.querySelector('[data-sample-progress]');
      button.disabled=button.dataset.sampleAvailable!=='true'||!grind.value||selects.some(s=>!s.value);
      status.textContent=status.dataset.progressTemplate.replace('__COUNT__',String(selects.filter(s=>s.value).length));
    };
    const tastes=new Set();
    const groups={
        chocolate: /chocolat|cocoa|cacao/i,
        sweet: /caramel|toffee|fudge|honey|molasses|sugar|sweet/i,
        nuts: /nut|almond|pecan|walnut|malt|hazelnut/i,
        fruit: /berr|cherry|cherries|plum|apple|peach|apricot|raisin|fruit|grape/i,
        citrus: /citrus|lemon|orange|lime|grapefruit|bergamot/i,
        earthy: /earth|tobacco|wood|cedar|herbal|herb-like/i,
        floral: /floral|flower|jasmine|tea-like|black tea|earl grey|bergamot/i,
        spice: /spic|cinnamon|clove|pepper|nutmeg|cardamom/i
      };
    form.querySelectorAll('[data-sample-taste]').forEach(b=>b.addEventListener('click',()=>{const t=b.dataset.sampleTaste;tastes.has(t)?tastes.delete(t):tastes.add(t);b.setAttribute('aria-pressed',String(tastes.has(t)));}));
    form.querySelector('[data-sample-recommend]')?.addEventListener('click',()=>{
      const status=form.querySelector('[data-sample-taste-status]');
      if(!tastes.size){status.textContent=status.dataset.prompt;return;}
      const ranked=[...selects[0].options].filter(o=>o.value&&!o.disabled).map((o,i)=>({o,i,score:[...tastes].filter(t=>groups[t]?.test(o.dataset.notes||'')).length})).sort((a,b)=>b.score-a.score||a.i-b.i);
      if(!ranked.length||ranked[0].score===0){status.textContent=status.dataset.none;return;}
      const matching=ranked.filter(item=>item.score>0).slice(0,3);
      selects.forEach((s,i)=>s.value=matching[i]?.o.value||'');
      status.textContent=matching.length===3?status.dataset.success:status.dataset.partial.replace('__COUNT__',String(matching.length));update();
    });
    selects.forEach(select=>select.addEventListener('change',update));
    grind.addEventListener('change',update);
    form.addEventListener('submit',event=>{if(!form.checkValidity()){event.preventDefault();form.reportValidity();}});
    if(window.location.hash==='#sample-flavours'){const d=form.querySelector('[data-sample-tastes]');if(d)d.open=true;}
    update();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initSamplePacks());}else{initSamplePacks();}
document.addEventListener('shopify:section:load',event=>initSamplePacks(event.target));

